import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  LanguagesSchema,
  reviewsLanguagesOptions,
} from "../../FacilityReportsComponents/FacilityReportsList/ModalCreateNew/Form/schema";

import "./styles.scss";

interface IHookFormLanguageSelectProps {
  name: string;
  label?: string;
  labelClassName?: string;
  className?: string;
  disabled?: boolean;
}

const options = Object.values(reviewsLanguagesOptions);

export const HookFormLanguageSelect = (props: IHookFormLanguageSelectProps) => {
  const { name, label, labelClassName, className, disabled } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`facilityReportsPage.modalCreateNew.fields.reviews.languages.${key}`);

  const { control } = useFormContext<LanguagesSchema>();

  return (
    <div className={`hook-form-language-select ${className || ""}`}>
      {label && (
        <label
          className={`hook-form-language-select-label ${labelClassName || ""} ${
            disabled ? "disabled" : ""
          }`}
          htmlFor={name}
        >
          {label}
        </label>
      )}
      <Controller
        control={control}
        name={`${name}.option` as "option"}
        render={({ field }) => (
          <div className="language-options">
            {options.map((option) => (
              <div key={option}>
                <input
                  disabled={disabled}
                  className="language-option-input"
                  type="radio"
                  checked={field.value === option}
                  id={`${name}-${option}`}
                  name={`${name}.option`}
                  onChange={() => field.onChange(option)}
                />
                <label
                  htmlFor={`${name}-${option}`}
                  className={disabled ? "disabled" : ""}
                >
                  {t(`options.${option}`)}
                </label>
              </div>
            ))}
          </div>
        )}
      />
    </div>
  );
};
